module.exports = __webpack_public_path__ + "img/b5d9590.svg";